// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"98f84fcf","239":"017af3b0","453":"766fac94","732":"36b40184"}[chunkId] + ".chunk.js";
};